import { useMemo } from 'react';
import { useAppSelector } from '../../app/app-hooks';
import { selectProfile } from '../api/slices/profile-slice';
import { useSegment } from '../providers/segment-provider';
import ClientAnalytics from './client-analytics';

export const useClientAnalytics = () => {
  const client = useAppSelector(selectProfile);
  const analytics = useSegment();
  return useMemo(
    () => new ClientAnalytics(analytics, client),
    [analytics, client],
  );
};
